import { RecoveryEmailPopupState } from '.'

export const getRecoveryEmailPopupVisible = (
  recoveryEmailPopup: RecoveryEmailPopupState
): boolean => recoveryEmailPopup.visible

export const getRecoveryEmailPopupSent = (
  recoveryEmailPopup: RecoveryEmailPopupState
): boolean => recoveryEmailPopup.sent
